export enum BookingErrorTypeEnum {
  ERROR_VALIDATION = 'ERROR_VALIDATION',
  ERROR_SERVICE = 'ERROR_SERVICE',
  ERROR = 'ERROR',
}

export enum BookingStepsEnum {
  SERVICES = 1,
  CALENDAR = 2,
  SUBMIT = 3,
  CONFIRM = 4,
}

export enum AlertStateEnum {
  NORMAL,
  NO_TIMESLOTS_REDIRECTED,
  NO_TIMESLOTS_FOR_DOCTOR,
  NO_TIMESLOTS_AT_ALL,
  NO_TIMESLOTS_SELECT_DOCTOR,
  NO_TIMESLOTS_AT_ALL_30,
  NO_TIMESLOTS_AT_ALL_90,
  NO_TIMESLOTS_NO_MATCH,
}

export enum StaffMembersSelectorEnum {
  OPTION_ANY_ID = '-1',
  OPTION_NO_SELECTION = '0',
}

export enum BookingParamsEnum {
  CAREPROVIDER_ID = 'providerId',
  SERVICE_ID = 'serviceId',
  TIMESLOT = 'timeslot',
  UNAVAILABLE = 'inte-tillganglig',
}

export enum BookingFormFieldTypeEnum {
  TEXT = 'Text',
  RADIO = 'Radio',
  BOOLEAN = 'Boolean',
  MULTISELECT = 'Multiselect',
  TEXTAREA = 'Textarea',
  DATEPICKER = 'DatePicker',
  PERSONAL_NUMBER = 'SwedishPersonalIdentityNumber',
  PHONE_NUMBER = 'PhoneNumber',
}

export enum BookingFormFieldsCssClasses {
  FULL = 'full-width',
  HALF = 'half-width',
}

export enum TherapistChoiceEnum {
  AVAILABLE = 'TherapistChoiceAvailable',
  UNAVAILABLE = 'TherapistChoiceUnavailable',
  REQUIRED = 'TherapistChoiceRequired',
}

export enum BookingVirtualServiceGroupIDsEnum {
  OTHERS = 99999999,
}

export enum SurveyAdditionalFieldsEnum {
  GDPR = 'gdpr',
  COUNTRY_CODE = 'pnCountryCode',
}
